import React, { useState } from 'react';
import { useMeasure } from 'react-use';
import classNames from 'classnames';
import useDarkMode from '../../hooks/useDarkMode';
import config from '../../config';
import { useMst } from '../../models';
import Modal, { ModalBody } from '../../components/bootstrap/Modal';
import { observer } from 'mobx-react';
import { useTranslation } from 'react-i18next';
import brand from "../../assets/images/brand_dark.png";
import kakao_icon from "../../assets/images/kakao_icon.png";
import Card, { CardBody } from '../../components/bootstrap/Card';

const Footer = observer(() => {
	const [ref, { height }] = useMeasure();
	const { user, company, notifiction } = useMst();
	const { t } = useTranslation(['translation', 'menu']);

	const root = document.documentElement;
	root.style.setProperty('--footer-height', `${height}px`);

	const { darkModeStatus } = useDarkMode();
	const [isCouponModalOpen, setIsCouponModalOpen] = useState(false);

	return (
		<footer ref={ref} className='footer p-0'>
			<Card className="w-100 m-0" style={{ backgroundColor: '#03FF99' }}>
				<CardBody className='d-flex flex-row justify-content-between footer-font1'>
					<div className='row w-100'>
						<div className='col-lg-4 d-none d-lg-block' style={{textAlign: 'right'}}>
							<img src={brand} alt="지음과 깃듬" />
						</div>
						<div className='col-lg-4' style={{minWidth: 380}}>
							<div>
								주식회사 지음과깃듬
							</div>
							<div className='footer-font2'>
								대표이사 : 김여정 | 사업자번호 : 1460-0860-03010
							</div>
							<div className='footer-font2'>
								서울 본사 : 서울특별시 강남구 논현로 134 연산MS빌딩, 501호
							</div>
							<div className='footer-font2'>
								김해 지사 : 경상남도 김해시 주촌면 골든루트로 80-16, 4층 406호 13
							</div>
							<div className='row footer-font2 mt-2'>
								<div className='col-auto'>
									이용약관
								</div>
								<div className='col-auto'>
									개인정보처리방침
								</div>
							</div>
						</div>
						<div className='col-lg-3 row'>
							<div className='col-auto'>
								<div className='footer-font1'>
									<img src={kakao_icon} alt="카카오톡" />
								</div>
							</div>
							<div className='col-auto mt-1'>
								<div className='footer-font2'>
									카카오톡 문의 : @지음과깃듬
								</div>
								<div className='footer-font2'>
									상담시간 평일 : 10 ~ 18시
								</div>
							</div>
						</div>
					</div>
				</CardBody>
			</Card>
			{/* <div style={{ backgroundColor: '#03FF99'}}>
				<div className='row g-3 text-start topmenu-container p-3 '>
					<div className='col-auto'>
						<div className='footer-font1'>
							<img src={brand} alt="지음과 깃듬" />
						</div>
					</div>
					<div className='col-auto'>
						<div className='footer-font1'>
							주식회사 지음과깃듬
						</div>
						<div className='footer-font2'>
							대표이사 : 김여정 | 사업자번호 : 1460-0860-03010
						</div>
						<div className='footer-font2'>
							서울 본사 : 서울특별시 강남구 논현로 134 연산MS빌딩, 501호 / 김해 지사 : 경상남도 김해시 주촌면 골든루트로 80-16, 4층 406호 13
						</div>
						<div className='row footer-font2 mt-2'>
							<div className='col-auto'>
								이용약관
							</div>
							<div className='col-auto'>
								개인정보처리방침
							</div>
						</div>
					</div>
					<div className='col-auto'>
						<div className='row g-3 text-start'>
							<div className='col-auto'>
								<div className='footer-font1'>
									<img src={kakao_icon} alt="카카오톡" />
								</div>
							</div>
							<div className='col-auto'>
								<div className='footer-font2'>
									카카오톡 문의 : @지음과깃듬
								</div>
								<div className='footer-font2'>
									상담시간 평일 : 10 ~ 18시
								</div>
							</div>
						</div>
					</div>
				</div>
			</div> */}
		</footer>
	);
});

export default Footer;
